import ActionType from '../constants/ActionTypes';

export default function controlsReducer(state = {}, action) {
    switch (action.type) {
        case ActionType.CHANGE_LANGUAGE_WAITING_STATE:
            return {
                ...state,
                languageLoading: true
            }

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/controlsReducer.js